import React, { useState, useEffect } from 'react';
import Http from '../../../Http';
import { Button, Grid, Typography, Card, CardContent } from '@material-ui/core';
import ModalActualizarPago from './ModalActualizarPago';
import moment from 'moment';

const Detalle = ({ pagoData, onUpdateSuccess }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        if (pagoData && pagoData.id) {
            cargarDetalle();
        }
    }, [pagoData]);

    const cargarDetalle = async () => {
        setLoading(true);
        let Res = await Http.get(`pago-transportista-detalle/${pagoData.id}`);
        if (!Res.error) {
            setData(Res.data);
        }
        setLoading(false);
    }

    const handleUpdate = () => {
        onUpdateSuccess();
    }

    if (loading) return <div>Cargando detalle...</div>;
    if (!data) return <div>Error al cargar datos.</div>;

    const { pago, historial } = data;

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle1"><strong>Guía:</strong> {pago.g_folio}</Typography>
                    <Typography variant="subtitle1"><strong>Transportista:</strong> {pago.transportista_nombre}</Typography>
                    <Typography variant="subtitle1"><strong>Chofer:</strong> {pago.chofer}</Typography>
                    <Typography variant="subtitle1"><strong>Origen:</strong> {pago.origen}</Typography>
                    <Typography variant="subtitle1"><strong>Destino:</strong> {pago.destino}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle1"><strong>Tipo de Pago:</strong> {pago.tipo_pago}</Typography>
                    <Typography variant="subtitle1"><strong>Cálculo Aplicado:</strong> {pago.tipo_calculo}</Typography>
                    <Typography variant="subtitle1"><strong>KM:</strong> {pago.km}</Typography>
                    <Typography variant="subtitle1"><strong>Valor Pagado:</strong> ${Number(pago.valor_pagado).toFixed(2)}</Typography>
                    <Typography variant="subtitle1"><strong>Registrado por:</strong> {pago.useradd_nombre} {pago.useradd_paterno}</Typography>
                </Grid>
            </Grid>

            <div style={{ marginTop: 20, marginBottom: 20, textAlign: 'right' }}>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => setModalOpen(true)}
                    style={{ marginRight: 10 }}
                >
                    Modificar Pago
                </Button>
                <Button variant="contained" color="default">
                    Imprimir PDF
                </Button>
            </div>

            <Typography variant="h6">Historial de Cambios</Typography>
            {historial && historial.length > 0 ? (
                historial.map((h, i) => (
                    <Card key={i} style={{ marginBottom: 10 }}>
                        <CardContent>
                            <Typography variant="body2" color="textSecondary">
                                Fecha: {moment(h.createdAt).format('DD/MM/YYYY HH:mm:ss')} por {h.useradd_nombre}
                            </Typography>
                            <Typography variant="body1">
                                Cambió de <strong>${Number(h.valor_previo).toFixed(2)}</strong> a <strong>${Number(h.valor_nuevo).toFixed(2)}</strong>
                            </Typography>
                            <Typography variant="body2">
                                <em>Motivo: {h.razon_cambio}</em>
                            </Typography>
                        </CardContent>
                    </Card>
                ))
            ) : (
                <Typography variant="body2">No hay modificaciones previas.</Typography>
            )}

            <ModalActualizarPago
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                pagoId={pago.id}
                valorPrevio={pago.valor_pagado}
                onSuccess={handleUpdate}
            />
        </div>
    );
};

export default Detalle;
